





































































import 'reflect-metadata'
import { Vue, Component } from 'vue-property-decorator'
import { P, X, C, getTxChainType } from '@/known_blockchains'
import {
    DEFAULT_NETWORK_ID,
    cChainExplorerURL,
    cChainExplorerURL_test,
} from '@/store/modules/network/network'

@Component({})
export default class TxHeader extends Vue {
    get xChain() {
        return getTxChainType(X.id)
    }

    get pChain() {
        return getTxChainType(P.id)
    }

    get cChain() {
        return getTxChainType(C.id)
    }

    get cChainURL() {
        return DEFAULT_NETWORK_ID === 1
            ? cChainExplorerURL
            : cChainExplorerURL_test
    }
}
